// Canonical ROUTES — CONTRACTS.md §11 (port of Routes.kt). Every doc imports ROUTES from here.
export const ROUTES = {
  login: '/login',
  dashboard: '/dashboard',
  pulse: '/pulse',
  users: '/users',
  admins: '/admins',
  systemPermissions: '/system/permissions',
  content: '/content',
  humanReview: '/content/human-review',
  frontierReview: '/content/frontier-review',
  autoReject: '/content/auto-reject',
  createTestPost: '/moderation/test-post',
  pipelineTestPosts: '/moderation/test-posts',
  pipelineLab: '/moderation/pipeline-lab',
  pipelineLabCase: (caseId: string) => `/moderation/pipeline-lab/${caseId}`,
  pipelineLabRun: (caseId: string, runId: string) =>
    `/moderation/pipeline-lab/${caseId}/runs/${runId}`,
  moderationRules: '/moderation/rules',
  moderationReports: '/moderation/reports',
  moderationDashboard: '/moderation/dashboard',
  moderation: '/moderation',
  // "Media" — the video-editor resources the mobile app loads from the CDN.
  // Stickers and transitions are single pages; effects keep their own five-tab
  // hub because authoring an effect is a pipeline, not a list.
  media: '/media',
  mediaStickers: '/media/stickers',
  mediaTransitions: '/media/transitions',
  effects: '/media/effects',
  effectPacks: '/media/effects/packs',
  tfxCreate: '/media/effects/create',
  tfxDrafts: '/media/effects/drafts',
  tfxReview: '/media/effects/review',
  tfxPublished: '/media/effects/catalog',
  campaigns: '/campaigns',
  finance: '/finance',
  engagement: '/engagement',
  userDetails: (id: string) => `/users/${id}`,
  userModerationHistory: (id: string) => `/users/${id}/moderation-history`,
  adminDetails: (id: string) => `/admins/${id}`,
  contentDetails: (id: string) => `/content/${id}`,
  // `type` = content-type variant; default "user" is applied in useParams.
  moderationDetails: (id: string, type: string) => `/moderation/${id}/${type}`,
} as const;
// Route patterns: /users/:userId, /users/:userId/moderation-history, /admins/:userId, /content/:contentId, /moderation/:moderationId/:type

// Shell-only extensions (the /403 page + landing target).
export const FORBIDDEN_PATH = '/403';
export const START_PATH = ROUTES.dashboard;
